import Vue from "vue";
import Vuex from "vuex";
import { now } from "./utils";
import DMAdminuser from "@/datamodels/Adminuser";

const DMStatic = {
	Adminuser: DMAdminuser,
};
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isLogin: false,
		userInfo: {
			userId: 0,
			userName: "",
			token: "",
		},
		userPrivilege: [],
		userPrivilegeMapping: {},
		hasMenuBar: true,
		cartCounter: 2,
		news: {},
		mainMenuActiveIndex: "dashboard",
		dataModels: {},
		loadingDM: false,
		picSign: {
			expire: 0,
		},
		loadingPicSign: false,
		classifies: [],
		stores: [],
		storeMapping: {},
		configs: {},
	},
	mutations: {
		setMenu(state, data) {
			state.hasMenuBar = data.show;
			state.mainMenuActiveIndex = data.mainMenuActiveIndex;
		},
		checkLogin(state) {
			if (state.isLogin) {
				return;
			}

			if (!localStorage.getItem("user_info")) {
				state.isLogin = false;
				return;
			}
			if (!localStorage.getItem("token_info")) {
				state.isLogin = false;
				return;
			}
			let userInfo = JSON.parse(localStorage.getItem("user_info"));
			let tokenInfo = JSON.parse(localStorage.getItem("token_info"));

			if (userInfo._id == 0) {
				state.isLogin = false;
				return;
			}
			state.isLogin = true;

			state.userInfo.userId = userInfo._id;
			state.userInfo.userName = userInfo.name;
			state.userInfo.token = tokenInfo.token;

			return;
		},
		doLoginToken(state, data) {
			state.isLogin = true;
			state.userInfo.userId = data.user_info._id;
			state.userInfo.userName = data.user_info.name;
			state.userInfo.token = data.token_info.token;

			localStorage.setItem("user_info", JSON.stringify(data.user_info));
			localStorage.setItem("token_info", JSON.stringify(data.token_info));
		},
		doLogout(state) {
			state.isLogin = false;

			state.userInfo.userId = 0;
			state.userInfo.userName = "";
			state.userInfo.token = "";

			localStorage.removeItem("user_info");
			localStorage.removeItem("token_info");
			localStorage.removeItem("userPrivilege");
		},
		getUserInfo(state) {
			let userInfo = JSON.parse(localStorage.getItem("user_info"));
			let tokenInfo = JSON.parse(localStorage.getItem("token_info"));

			state.userInfo.userId = userInfo._id;
			state.userInfo.userName = userInfo.name;
			state.userInfo.token = tokenInfo.token;
		},
		setUserInfo(state, data) {
			for (let k in data) {
				state["userInfo"][k] = data[k];
			}
			state.isLogin = true;
		},
		checkPrivilege(state) {
			//注意，权限虽然先用 localstorage 设置，还是必须走一次服务器
			if (localStorage.getItem("userPrivilege")) {
				state.userPrivilege = JSON.parse(localStorage.getItem("userPrivilege"));
				state.userPrivilegeMapping = state.userPrivilege.reduce(
					(accumulator, currentValue) => {
						accumulator[currentValue] = 1;
						return accumulator;
					},
					{},
				);
			}
			window.$http
				.get(`/admin/get_privilege/`)
				.then(json => {
					state.userPrivilege = json.data.privilege;
					sessionStorage.setItem("userPrivilege", JSON.stringify(json.data.privilege));
					state.userPrivilegeMapping = state.userPrivilege.reduce(
						(accumulator, currentValue) => {
							accumulator[currentValue] = 1;
							return accumulator;
						},
						{},
					);
				})
				.catch(err => {
					console.error(err);
				});
		},
		checkDataModel(state, dmName) {
			if (state.dataModels[dmName]) {
				return;
			}
			//先看本地
			if (DMStatic[dmName]) {
				state.dataModels[dmName] = DMStatic[dmName];
				state.dataModels = Object.assign({}, state.dataModels);
				return;
			}
			//先看缓存
			let data = sessionStorage.getItem("dm_" + dmName);
			data = false;
			if (data) {
				let dm = JSON.parse(data);
				state.dataModels[dmName] = {};
				for (let k in dm) {
					state.dataModels[dmName][k] = dm[k];
				}
				state.dataModels = Object.assign({}, state.dataModels);
				return;
			}
			state.loadingDM = true;
			window.$http
				.get(`/curd/list_model/${dmName}`)
				.then(json => {
					state.loadingDM = false;
					state.dataModels[dmName] = {};
					for (let k in json.data.schema) {
						state.dataModels[dmName][k] = json.data.schema[k];
					}

					sessionStorage.setItem(
						"dm_" + dmName,
						JSON.stringify(state.dataModels[dmName]),
					);
					state.dataModels = Object.assign({}, state.dataModels);
				})
				.catch(err => {
					console.error(err);
					state.loadingDM = false;
				});
		},
		getPicSign(state) {
			if (state.loadingPicSign) {
				//有人在做事
				return;
			}
			// 从localStorage中取签名，判断签名有没有过期
			state.loadingPicSign = true;
			let sign = localStorage.getItem("sign");
			let res;
			if (!sign) {
				res = { expire: 0 };
			} else {
				res = JSON.parse(sign);
			}

			var timestamp = now() / 1000;
			if (res.expire - 3 > timestamp) {
				state.loadingPicSign = false;
				state.picSign = res;
			} else {
				window.$http
					.get("/admin/sign/aliyun/lesmo")
					.then(json => {
						localStorage.setItem("sign", JSON.stringify(json.data));
						state.loadingPicSign = false;
						state.picSign = json.data;
					})
					.catch(err => {
						state.loadingPicSign = false;
						console.error(err);
					});
			}
		},
		//force 强制刷新
		getConfigs(state, force = true) {
			if (!force) {
				if (state.configs.length > 0) {
					//已经有了不管
					return;
				}
				//在看 localstorage
				let configs = sessionStorage.getItem("n_configs");
				if (configs) {
					state.configs = JSON.parse(configs);
					return;
				}
			}
			window.$http
				.get("/setting/configs")
				.then(json => {
					let configs = {};
					json.data.datas.forEach(val => {
						configs[val.name] = val.value;
					});
					sessionStorage.setItem("n_configs", JSON.stringify(configs));
					state.configs = configs;
				})
				.catch(err => {
					console.error(err);
				});
		},
		getClassifies(state, force = false) {
			if (!force) {
				if (state.classifies.length > 0) {
					//已经有了不管
					return;
				}
				//在看 localstorage
				let classifies = sessionStorage.getItem("n_classifies");
				if (classifies) {
					state.classifies = JSON.parse(classifies);
					return;
				}
			}
			window.$http
				.get("/classify/lists")
				.then(json => {
					sessionStorage.setItem("n_classifies", JSON.stringify(json.data.datas));
					state.classifies = json.data.datas;
				})
				.catch(err => {
					console.error(err);
				});
		},
		getStores(state, force = false) {
			if (!force) {
				if (state.stores.length > 0) {
					//已经有了不管
					return;
				}
				//在看 localstorage
				let stores = sessionStorage.getItem("n_stores");
				if (stores) {
					state.stores = JSON.parse(stores);
					state.storesMapping = state.stores.reduce((accumulator, currentValue) => {
						accumulator[currentValue._id] = currentValue;
						return accumulator;
					}, {});
					return;
				}
			}
			window.$http
				.get("/curd/lists/store")
				.then(json => {
					sessionStorage.setItem("n_stores", JSON.stringify(json.data.datas));
					state.stores = json.data.datas;
					state.storesMapping = state.stores.reduce((accumulator, currentValue) => {
						accumulator[currentValue._id] = currentValue;
						return accumulator;
					}, {});
				})
				.catch(err => {
					console.error(err);
				});
		},
	},
});
